import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset", { token, password });
      toast.success("Password updated. Please log in.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center px-4 bg-slate-50">
      <Card className="w-full max-w-md p-8 rounded-2xl">
        <h1 className="font-display text-2xl font-bold mb-4">Choose a new password</h1>
        <form onSubmit={submit} className="space-y-4">
          <Input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-lg" placeholder="New password" />
          <Button data-testid="reset-submit" disabled={busy} type="submit" className="w-full h-12 rounded-full bg-primary">
            {busy ? "Updating…" : "Update password"}
          </Button>
        </form>
        <p className="text-center text-sm text-slate-500 mt-6"><Link to="/login" className="text-primary hover:underline">Back to log in</Link></p>
      </Card>
    </div>
  );
}
